import React from 'react';
export function HeroSection() {
  return <section className="relative pt-16 pb-0 md:pt-28 overflow-hidden" style={{
    backgroundColor: '#1F1A17'
  }} data-id="element-44">
      {/* Glow */}
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-45" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center pl-[3px] pr-[3px] mt-[-35px] mb-[-35px]" data-id="element-46">
        {/* Brand */}
        <div className="animate-fade-in-up inline-flex items-center gap-2 px-5 py-2 rounded-full bg-gray-900 border border-gray-800 text-emerald-500 text-sm font-bold tracking-wider pt-[1px] pb-[1px] mt-[8px] mb-[8px]" data-id="element-47">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-48" />
          NEXO RECURSOS™
        </div>

        {/* Headline */}
        <h1 className="animate-fade-in-up delay-100 sm:text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-6 text-[28px]" data-id="element-49">
          Recuperá Tu Tiempo y Ordená Tu Empresa Con Este Sistema en 7 Días
        </h1>

        {/* Product Mockup */}
        <div className="animate-fade-in-up delay-150 flex justify-center mb-8" data-id="element-50">
          <img src="https://cdn.magicpatterns.com/uploads/bvwv3MUjJMZq6E9eHrLMxN/forbes_png_(1).png" alt="Mega Kit Maestría Operativa 2026 — Nexo Recursos" className="w-full max-w-md md:max-w-lg drop-shadow-2xl mt-[-25px] mb-[-25px]" data-id="element-51" />
        </div>

        {/* Product Card */}
        <div className="animate-fade-in-up delay-200 bg-gray-900/80 border border-emerald-500/30 rounded-2xl p-6 md:p-8 mb-8 relative overflow-hidden pt-[3px] pb-[3px]" data-id="element-52">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-600 via-emerald-400 to-emerald-600" data-id="element-53" />
          <h2 className="text-xl md:text-3xl text-white mb-3 font-[800]" data-id="element-54">
            MEGA KIT: MAESTRÍA OPERATIVA 2026
          </h2>
          <p className="md:text-lg text-emerald-400 mb-4 text-[14px] font-[900]" data-id="element-55">
            El sistema N°1 para dueños de PyME en Argentina - Estructura +
            Equipo + Estrategia + Ejecución + Eficiencia + Liderazgo
          </p>
          <p className="text-gray-300 md:text-lg max-w-3xl mx-auto text-[14px]" data-id="element-56">
            Procesos + delegación + control + estrategia listos para
            implementar. Sin perder más tiempo operando a ciegas.
          </p>
        </div>

        {/* CTA */}
        <div className="animate-fade-in-up delay-300 flex flex-col items-center mb-6" data-id="element-57">
          <a href="#pricing" className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-10 py-5 text-lg md:text-xl font-bold text-gray-950 bg-emerald-500 hover:bg-emerald-400 rounded-xl transition-all active:scale-95 mb-4" data-id="element-58">
            → QUIERO MI MEGA KIT AHORA
          </a>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/20 text-red-500 text-sm md:text-base font-bold mb-4 shadow-[0_0_15px_rgba(239,68,68,0.15)]" data-id="element-59">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-60" />
            ¡Quedan 4 cupos para acceder HOY a los 6 bonos!
          </div>

          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mt-2 text-xs md:text-sm font-medium text-gray-500" data-id="element-61">
            <span data-id="element-62">🛡️ Garantía 7 días</span>
            <span className="hidden sm:inline text-gray-700" data-id="element-63">|</span>
            <span data-id="element-64">🔒 Pago seguro</span>
            <span className="hidden sm:inline text-gray-700" data-id="element-65">|</span>
            <span data-id="element-66">💳 Mercado Pago</span>
          </div>
        </div>
        {/* Badges */}
        <div className="animate-fade-in-up delay-400 flex flex-wrap md:gap-3 mt-[6px] mb-12 gap-[4px] flex-row items-start justify-center" data-id="element-67">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Contexto Argentina 2026', '📚 6 Tomos + 6 Bonos', '🔒 Pago seguro'].map((b, i) => <span key={i} className="px-3 py-1.5 md:px-4 md:py-2 rounded-lg bg-gray-800/80 text-gray-200 text-xs md:text-sm font-medium border border-gray-700 pt-[6px] pb-[6px]" data-id="element-68">
              {b}
            </span>)}
        </div>

        {/* Video Preview */}
        <div className="animate-fade-in-up delay-500 max-w-3xl mx-auto mb-16 rounded-2xl overflow-hidden border border-gray-700 shadow-2xl bg-gray-900" data-id="element-69">
          <video src="https://cdn.magicpatterns.com/uploads/jtYNDPeZTX76K9YwYAqz7X/captura%20para%20magic.mp4" autoPlay loop muted playsInline className="w-full h-auto object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-70" />
        </div>
      </div>

      {/* Stats Bar */}
      <div className="animate-fade-in delay-600 border-y border-gray-800 bg-gray-900/60" data-id="element-71">
        <div className="max-w-5xl mx-auto px-4" data-id="element-72">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-6 py-8 md:py-10" data-id="element-73">
            {[{
            val: '+300',
            label: 'dueños de PyME ya lo tienen'
          }, {
            val: '6',
            label: 'Tomos completos'
          }, {
            val: '6',
            label: 'Bonos incluidos'
          }, {
            val: '4.9/5 ★',
            label: 'calificación'
          }].map((s, i) => <div key={i} className="text-center px-4" data-id="element-74">
                <div className="text-2xl md:text-4xl font-bold text-white mb-1" data-id="element-75">
                  {s.val}
                </div>
                <div className="text-[11px] md:text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-76">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}